export default {
	'Rechercher un fichier': 'Nach Dateien suchen',
	selectedfiles: 'Keine Datei ausgewählt | {count} Datei ausgewählt | {count} Datei ausgewählt',
	titleselection: 'Ihre Auswahl | Ihre Auswahl, {count} Datei | Ihre Auswahl, {count} Dateien',
	results: {
		infos: 'Aucun résultat | {count} fichier, <strong>voir le résultat</strong> | {count} fichiers, <strong>voir les résultats</strong>'
	},
	'Adresse postales': 'Mail address',
	'Moins de 50 ans': 'Weniger als 50 Jahre',
	filename: 'Schlagwörter; Senioren, Haus',
	selectioninfo: "Un récapitulatif de votre sélection accompagnera l’email de confirmation de votre demande. Vous trouverez également un <a href='{link}' target='_blank'>lien pour télécharger</a> le document pdf de la sélection.",
	fichier: {
		couplage: {
			asile: {
				range: 'von {min} bis {max} g',
				beyond: 'jenseits von %s g'
			}
		}
	},
	pagination: {
		title: 'Siehe {count} weitere Dateien',
		subtitle: '{count} von {total} angezeigten Dateien',
		total: 'Keine Dateien vorhanden | {count} Datei verfügbar | {count} Dateien verfügbar',
	},
	searchsite: {
		pagination: {
			total: '{count} ergebnisse | {count} ergebnis | {count} ergebnis',
		}
	},
	'Votre sélection':'Ihre Auswahl',
	'Inclure ma sélection avec ma demande':'Meine Auswahl mit meiner Bewerbung einschließen',
	'Télécharger le pdf':'pdf herunterladen',
	'Consommation':'Konsumverhalten',
	'Réaction':'Reaktion',
	'Activité':'Aktivität',
	"Mode d'achat":'Art des Kaufs',
	"Ajouter à la sélection":"Zur Auswahl hinzufügen",
	"Fichier ajouté à la sélection":"Datei zur Auswahl hinzugefügt",
	"Fichier retiré de la sélection":"Datei aus der Auswahl entfernt",
	'Filtrez par univers':'Nach Universum filtern',
	'Filtrez par canal':'Nach Kanal filtern',
	'Voir les filtres avancés': 'Erweiterte Filter ansehen',
	'Votre adresse de contact': 'Ihre Kontaktadresse',
	"Votre adresse email":"Deine E-Mail-Adresse",
	"Renseignez votre adresse email afin que nos équipes puissent vous conseiller !":"Geben Sie Ihre E-Mail-Adresse an, damit unsere Teams Sie beraten können!",
	"En renseignant votre adresse email, vous acceptez d'être recontacté par ITL et vous reconnaissez avoir pris connaissance de notre politique de confidentialité.": 'Durch die Angabe Ihrer E-Mail-Adresse erklären Sie sich damit einverstanden, von ITL kontaktiert zu werden, und Sie bestätigen, dass Sie unsere Datenschutzbestimmungen zur Kenntnis genommen haben.',
	'Profils':'Profile',
	'Sélections possibles':'Mögliche Auswahlen',
	'Âge moyen':'Durchschnittliches Alter',
	'ans':'Jahre',
	'Prix':'Preis',
	'Délai':'Frist',
	'Données variables':'Variable Daten',
	'Nous consulter':'Bitte fragen Sie uns',
	'Déduplication':'Deduplizierung',
	'Frais informatiques':'Computerkosten',
	'Frais de sélection':'Kosten für die Auswahl',
	'Au mille':'Auf Tausend',
	'Coût pour mille (CPM)':'Kosten pro Tausend (CPM)',
	"Nous consulter pour plus d'informations.":'Konsultieren Sie uns für weitere Informationen.',
	'Commentaire':'Kommentar',
	'Commande moyenne':'Mittlere Bestellung',
	'Potentiels':'Potenziale',
	'Poids maximum':'Maximales Gewicht',
	'Format maximum':'Maximales Format',

	'Filtrer par univers': 'Nach Universen filtern',
	'Inclure les fichiers présents dans les univers sélectionnés.': 'Dateien einschließen, die in den ausgewählten Universen vorliegen.',
	'Femmes actives': 'Aktive Frauen',
	'Santé beauté bio': 'Gesundheit Schönheit Bio',
	'Maison loisir': 'Haus und Freizeit',
	'Santé senior': 'Gesundheit Senioren',
	'Vins gastronomie': 'Wein und Gastronomie',
	'Filtrer par canaux': 'Nach Kanälen filtern',
	'Inclure les fichiers ayant les canaux sélectionnés.': 'Dateien mit den ausgewählten Kanälen einschließen.',
	'Adresses emails': 'E-Mail-Adressen',
	'Adresses postales': 'Postadressen',
	'Téléphones': 'Telefone',
	'Asile colis': 'Paketbeilagen',
	'Asile-colis': 'Paketbeilagen',
	'Encarts presse': 'Pressebeilagen',
	'Copier la recherche': 'Suche kopieren',
	'Fermer la recherche': 'Suche schließen',
	'Comment pouvons  nous vous aider ? ': 'Wie können wir Ihnen helfen? ',
	'Vous souhaitez en savoir plus - nous contacter': 'Sie möchten mehr erfahren - kontaktieren Sie uns',
	'Vous avez un projet - nous en parler': 'Sie haben ein Projekt - sprechen Sie mit uns darüber',
	'Vous avez besoin de conseils ?  Discutez avec un de nos specialistes': 'Sie brauchen eine Beratung?  Diskutieren Sie mit einem unserer Spezialisten',
	'Votre message': 'Ihre Nachricht',
	'Ecrivez nous votre message': 'Schreiben Sie uns Ihre Nachricht',
	'qui êtes vous ': 'Wer sind Sie ',
	'Société': 'Unternehmen',
	'Prénom': 'Vorname',
	'Nom': 'Name',
	'E-mail': 'E-Mail',
	'Téléphone': 'Telefon',
	'envoyez ma demande': 'Meine Anfrage senden',
	'Parler-nous de votre projet': 'Erzählen Sie uns von Ihrem Projekt',
	'Informations complémentaires': 'Weitere Informationen',
	'Adresse': 'Adresse',
	'Ville': 'Stadt',
	'Code postal': 'Postleitzahl',
	'Réinitialiser': 'Reset',
	'Résultat de la recherche': 'Ergebnis der Suche',
	'Effacer': 'Löschen',
	'Potentiel': 'Potenzial',
	'Télécharger la sélection': 'Auswahl downloaden',

	'Boîte à outils': 'Auswahl downloaden',
	'Fermer':'Schließen',
	'Résultat':'Ergebnisse',
	'Sélectionnez un outils pour commencer à calculer !':'Wählen Sie ein Tool aus, um mit dem Rechnen zu beginnen!',
	"Taux de rendement":'Rendite Rate',
	"Estimez le taux de rendement de votre prochaine opération":'Schätzen Sie die Renditerate für Ihr nächstes Geschäft.',
	"Estimez le coût d'acquisition d'un nouveau client suite à une opération de marketing direct":'Schätzen Sie die Kosten für die Gewinnung eines neuen Kunden nach einer Direktmarketingaktion.',

	'Remplissez les champs pour estimer le taux de rendement de votre prochaine opération':'Füllen Sie die Felder aus, um die Ertragsrate für Ihre nächste Operation zu schätzen.',
	"Taille de l'échantillon testé":'Größe der getesteten Stichprobe',
	'Taux de rendement sur cet échantillon (%)':'Rendite für diese Stichprobe (%).',
	"Remplissez les champs pour afficher votre intervalle de confiance.":'Füllen Sie die Felder aus, um Ihr Vertrauensintervall anzuzeigen.',
	"L'intervalle de confiance":'Das Vertrauensintervall',
	"En marketing direct, il est nécessaire d'être prévoyant pour éviter toute erreur.":'Im Direktmarketing muss man Voraussicht walten lassen, um Fehler zu vermeiden.',
	"C'est pourquoi nous vous proposons de découvrir ci-dessous un outil de prévision très facile à utiliser pour vous permettre d'évaluer le taux de remontée de vos futures campagnes en fonction des résultats d'un test. Cet outil basé sur le tableau d'Otheiner, vous permet de déterminer l'intervalle de confiance, c'est-à-dire les limites basses et hautes dans lesquelles vous pourrez prévoir le rendement de votre action sur la globalité ou partie d'un fichier dont vous avez testé un échantillon au préalable.":'Im Folgenden möchten wir Ihnen ein sehr einfach zu verwendendes Prognosetool vorstellen, mit dem Sie die Wiederaufstiegsrate Ihrer zukünftigen Kampagnen auf der Grundlage von Testergebnissen einschätzen können. Dieses auf der Otheiner-Tabelle basierende Tool. Es ermöglicht die Bestimmung des Vertrauensintervalls.',
	"Source : d'après le tableau de R. Ostheiner de Time Inc. réalisé pour la DMA et les travaux de Pierre Boeglin dans l'utilisation de la loi de Gauss dans l'interprétation des tests.":"Quelle: Nach der von R. Ostheiner von Time Inc. für die DMA erstellten Tabelle und der Arbeit von Pierre Boeglin in der Verwendung des Gauß'schen Gesetzes bei der Interpretation von Tests.",
	'La fiabilité des résultats du test dépend non pas de la taille du fichier testé mais de la taille de votre échantillon (qui ne doit être ni de taille trop réduite, ni trop importante, ce qui conduirait à des prises de risques inutiles).':'Die Zuverlässigkeit der Testergebnisse hängt nicht von der Größe der getesteten Datei ab, sondern von der Größe Ihrer Stichprobe (die weder zu klein noch zu groß sein sollte, da dies zu unnötigen Risiken führen würde).',
	"Rendement":"Ertrag",
	"Exemple : Rendement 1,3 % sur 10 000 envois de messages, soit 130 réponses en moyenne.":'Beispiel: Rendite 1,3 % bei 10 000 Nachrichtensendungen, d. h. durchschnittlich 130 Antworten.',

	"Coût d'acquisition":'Kosten der Akquise',
	"Calculez le cout d'acquisition d'un nouveau client suite à une opération de marketing direct":"Berechnen Sie die Kosten für die Gewinnung eines neuen Kunden aufgrund einer Direktmarketingaktion.",
	"Coût de la campagne (€) *":'Kosten der Kampagne (€)',
	"Nombre de nouveaux clients *":'Anzahl der Neukunden',
	"Coût total des produits (€) *":'Gesamtkosten der Produkte (€)',
	"Coût total du transport":'Gesamtkosten für den Transport',
	"Coût total des cadeaux":'Gesamtkosten für Geschenke',
	"Chiffre d'affaire (€) *":'Umsatz (€)',
	"Remplissez les champs pour déterminer votre coût d'acquisition.":'Füllen Sie die Felder aus, um Ihre Akquisitionskosten zu ermitteln.',
	"Les clients recrutés ne vous ont":'Die geworbenen Kunden haben Sie nichts',
	"rien coûté":'gekostet',
	"Chaque nouveau client recruté vous a rapporté":'Jeder neu geworbene Kunde hat Ihnen eine Gewinnspanne von',
	"de marge":'eingebracht',
	"Vous avez investi":'Sie haben investiert',
	"pour recruter un client":'um einen Kunden zu werben',
	"Minimum de location":'Mindestmiete',
	'Aucun fichier disponible pour cette recherche':'Keine Datei für diese Suche verfügbar',
	'Réinitialiser les filtres':'Filter zurücksetzen',
	'Aucun résultat pour ces critères de recherche':'Keine Ergebnisse für diese Suchkriterien',
	"Essayez avec d'autres paramètres":"Versuchen Sie es mit anderen Parametern",
}
